import { CheckCircleIcon, CircleCrossIcon, InfoIcon } from '@fukuri-admins/ui/common/Icons';
import styles from './styles.module.scss';

/**
 * 一括追加・更新モーダルで表示する「できること・できないこと」案内コンポーネント。
 * 表示項目は固定。props は受けず汎用化しない。
 */
export const BulkCreationGuideAlert = () => (
  <div className={styles.container}>
    <div className={styles.left}>
      <div className={styles.iconWrap}>
        <InfoIcon size='md' aria-hidden />
      </div>
      <div className={styles.body}>
        <div className={styles.titleWrapper}>
          <span className={styles.title}>できること・できないこと</span>
        </div>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            <span className={styles.canIcon}>
              <CheckCircleIcon size='xs' aria-hidden />
            </span>
            <span className={styles.itemText}>利用者の新規追加</span>
          </li>
          <li className={styles.listItem}>
            <span className={styles.canIcon}>
              <CheckCircleIcon size='xs' aria-hidden />
            </span>
            <span className={styles.itemText}>利用者の氏名および事業所情報の更新</span>
          </li>
          <li className={styles.listItem}>
            <span className={styles.cannotIcon}>
              <CircleCrossIcon size='xs' aria-hidden />
            </span>
            <span className={styles.itemText}>
              利用者のメールアドレス変更（個別画面から行ってください）
            </span>
          </li>
          <li className={styles.listItem}>
            <span className={styles.cannotIcon}>
              <CircleCrossIcon size='xs' aria-hidden />
            </span>
            <span className={styles.itemText}>
              利用者の削除（一覧画面または一括削除から行ってください）
            </span>
          </li>
          <li className={styles.listItem}>
            <span className={styles.cannotIcon}>
              <CircleCrossIcon size='xs' aria-hidden />
            </span>
            <span className={styles.itemText}>空白セルでの上書き</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
);
